import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import bootbox from 'bootbox'
import { toast } from 'react-toastify'

import { appendModel, deleteSite, modifyModelAttr, orgChange  } from '../../../../features/site/siteSlice'
import { addSite, updateSite, deleteSiteById, uploadLogo } from '../../../utils/Organizations'
import { generatePassword, getImageSpecs, toBase64 } from '../../../utils/common'
import { USER_FORM, checkUserExists, getUsers, postUser, updateUser } from '../../../utils/Users'
import usePrevious from '../../../hooks/UsePrevious'
import SidePanelToggle from '../../Layout/Common/SidePanelToggle'
import SalesTokenCompanies from '../SalesTokenCompanies'

function SalesTokenModification(props){
    const dispatch = useDispatch()

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)

    const [refServicePanel, setRefServicePanel] = useState(false)

    const [tokenChecker, setTokenChecker] = useState({
        loading: false,
        exists: null
    })
    const [logo, setLogo] = useState(null)

    useEffect(() => {
        if(isAdmin && model?.tokenForm?.sitePath){
           getUsers(model?.tokenForm?.siteId ?? null)
            .then((userResp) => {
                let users = []
                if(userResp.response){
                    users = userResp?.response?.users || []
                }
                
                dispatch(appendModel({
                    userForm: {...USER_FORM, password: generatePassword(12)},
                    users
                }))
            })
            
        }
        return () => {
            if(model.users?.length > 0){
                dispatch(appendModel({
                    users: []
                }))
            }
        }                
    }, [model?.tokenForm?.siteId])

    useEffect(() => {
        if(model?.tokenForm?.siteId?.length >= 3){
            setTokenChecker({
                loading: true,
                exists: false
            })  
        } else {
            setTokenChecker({
                loading: false,
                exists: null
            })  
        }
        const timeoutId = setTimeout(() => {
            onTokenChange()
        }, 2000)

        return () => clearTimeout(timeoutId)
    }, [model?.tokenForm?.siteId])

    const onDelete = async() => {
        bootbox.confirm({
            size: "small",
            title: `Corfirmation`,
            message: `Are you sure you want to delete ${model.tokenForm.name}?`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> No'
                },
                confirm: {
                    className: 'btn-danger',
                    label: '<i class="fa fa-check"></i> Yes'
                }
            },
            callback: async function (result) {
                if(result){

                    const {response, error } = await deleteSiteById(model?.tokenForm?.siteId)
                    
                    if(response){
                        toast.success("Sales Token has been deleted", {containerId: "defaultToastContainer"})

                        await dispatch(deleteSite({
                            siteId: model?.tokenForm?.siteId, 
                            siteType: "TOKEN"
                        }))

                        await props.onDeleteSite(model?.tokenForm?.siteId, "TOKEN")
                    }
                }
            }
        });

    }

    const onChange = (property="attr", bool=false) => (e) => {
        let modelCopy = {tokenForm: {...model.tokenForm}}

        if(property){
            modelCopy.tokenForm[property] = {
                ...modelCopy.tokenForm[property],
                [e.target.name]: bool ? !modelCopy.tokenForm[property][e.target.name] : e.target.value
            }
        } else {
            modelCopy.tokenForm[e.target.name] = bool ? !modelCopy.tokenForm[e.target.name] : e.target.value
        }

        dispatch( modifyModelAttr({
            key:`tokenForm`,
            body: modelCopy.tokenForm
        }))
    }


    const onChangeUser = (bool=false) => (e) => {
        dispatch(appendModel({
            userForm: {
                ...model.userForm,
                [e.target.name]: bool ? !model.userForm[e.target.name] : e.target.value
            }
        }))
    }

    const addUser = async() => {
        if(isAdmin){
            const uForm = {...model.userForm}
            uForm.siteId = model.tokenForm.siteId
            
            const { response, error } = await postUser(uForm)

            if(response){
                uForm.userId = response.result.userId
                
                await dispatch(appendModel({
                    userForm: uForm,
                    users: [{...uForm}]
                }))                
            }
        }
    }

    const saveUser = (u, idx) => async(e) => {
        if(isAdmin){
            let user = {...u}
            let users = [...model.users]
            user[e.target.name] = user[e.target.name] === undefined ? true : !user[e.target.name]

            users[idx] = user
            dispatch(appendModel({
                users
            }))

            await updateUser(null, user)

        }
    }

    const saveSite = async() => {
        if(model?.tokenForm?.sitePath) {
            let logoUrl = model.tokenForm?.attr?.logo ?? null

            if(model?.users?.length === 0 && !model.tokenForm?.attr?.isAffiliate){
                const responseExists = await checkUserExists(model.userForm.email)

                if(responseExists?.response && !responseExists?.response?.exists){
                    await addUser()                    
                }
            }

            if(logo !== null){
                const respLogo = await uploadLogo(logo)
                let logoObj = respLogo?.response ? JSON.parse(new TextDecoder().decode(respLogo?.response)) : {}

                logoUrl = logoObj?.logoUrl ?? null
            }

            await updateSite(model.tokenForm?.siteId, null, {
                site: {
                    ...model.tokenForm,
                    attr: {
                        ...model?.tokenForm?.attr,
                        logo: logoUrl
                    }
                }
            })

            let salesTokens = [...model.salesTokens]
            const idx = salesTokens.findIndex(t => t.siteId === model?.tokenForm?.siteId)

            salesTokens[idx] = model.tokenForm
            
            dispatch(appendModel({
                salesTokens
            }))

            toast.success("Update successful", {containerId: "defaultToastContainer"})
        } else {
            if(model?.tokenForm?.name === "" ||
                model?.tokenForm?.siteId?.length < 3){
                toast.error("Sales token value must be at least three characters long and description must not be empty", {containerId: "defaultToastContainer"})
                return
            }

            if(tokenChecker.exists){
                toast.error("Sales token already exists. Please use another token value")
                return
            }

            let logoUrl = null

            if(logo !== null){
                const respLogo = await uploadLogo(logo)
                
                let logoObj = respLogo?.response ? JSON.parse(new TextDecoder().decode(respLogo?.response)) : {}
                logoUrl = logoObj?.logoUrl ?? null
            }

            let sForm = {
                ...model.tokenForm,
                attr: {
                    ...model.tokenForm.attr,
                    logo: logoUrl
                }
            }
            
            if(!sForm?.attr?.isAffiliate){
                const responseExists = await checkUserExists(model.userForm.email)

                if(!responseExists?.response || responseExists?.response?.exists){
                    toast.error("User email is already taken. Please use another email address")
                    return
                }
            }

            const {response, error} = await addSite(null, {
                site: sForm
            })
            
            if(response.sitePath){
                sForm.sitePath = response.sitePath
            } else {
                sForm.sitePath = "/" + sForm.siteId
            }

            if(!sForm?.attr?.isAffiliate){
                await addUser()
            }

            dispatch(appendModel({
                salesTokens: [...model.salesTokens, {...sForm}],
                tokenForm: sForm
            }))
            
            toast.success("Sales token has been created successfully", {containerId: "defaultToastContainer"})
        }

    }

    const onTokenChange = () => {
        const { tokenForm } = model
        
        if(tokenForm?.siteId?.length >= 3){    

            const exists = model.salesTokens.reduce((prev, curr) => {
                if(curr?.siteId?.toLowerCase() === tokenForm?.siteId?.toLowerCase()){
                    prev = true
                }
                
                return prev
            }, false)                
            
            setTokenChecker({
                loading: false,
                exists
            })
        } else {
            setTokenChecker({
                loading: false,
                exists: null
            })
        }
    }

    const onLogoChange = async(e) => {     
        const file = e.target.files[0]
        
        setLogo(file)
    }

    const { tokenForm, userForm, users } = model

    return <>
        <div class="card card-raised h-100">
            <div class="card-body p-20">
                <div className="d-flex justify-content-between align-items-center">
                    <div class="overline text-muted mb-4">{props.title}</div>
                    <div className="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                        <div className="btn-group">
                            <button className="btn btn-lg btn-primary" disabled={!tokenForm?.siteId && (tokenChecker.exists !== false || tokenChecker.loading)} onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {tokenForm?.siteId && <>
                                <button type="button" class="btn btn-warning dropdown-toggle btn-lg" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Options
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:;" onClick={e => setRefServicePanel(true)}>
                                        Connected Companies
                                    </a>
                                </div>
                            </>}
                            {tokenForm?.siteId && <button className="btn btn-lg btn-outline-danger" id="tokenDeleteSite" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>
                    </div>
                    <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none">
                        <div className="btn-group">
                            <button className="btn btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {tokenForm?.siteId && <button className="btn btn-lg btn-outline-danger" id="tokenDeleteSite" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>
                    </div>
                </div>
                <h1 className="d-none d-sm-none d-md-none d-lg-block d-xl-block">{tokenForm?.siteId}</h1>
                <h2 className="d-block d-sm-block d-md-block d-lg-none d-xl-none">{tokenForm?.siteId}</h2>
                <form class="form-horizontal">
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">Token:</label>
                        <div class="col-sm-6">
                            <div class="input-group">
                                <input type="text"  class={`form-control${tokenForm.sitePath ? "-plaintext" : ""} ${(tokenForm?.siteId?.length > 0 && tokenForm?.siteId?.length < 3) ? "is-invalid" : ""}`} name="siteId" value={tokenForm?.siteId} onChange={tokenForm.sitePath ? () => {} : onChange(null)} />
                                {(!tokenForm?.sitePath && tokenChecker.exists !== null) && <div class="input-group-append" title={tokenChecker.loading ? "Loading" : tokenChecker.exists !== null ? tokenChecker.exists ? "This Sales Token is already taken" :  "This Sales Token is available!" : ""}>
                                    <span class="input-group-text">
                                        {tokenChecker.loading ? <div className="spinner-grow spinner-grow-sm text-info" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div> : tokenChecker.exists !== null ? <i className={`${tokenChecker.exists ? "fas fa-times-circle text-danger" : "fas fa-check-circle text-success"}`}></i> : <></>}
                                    </span>
                                </div>}
                            </div>
                            {(tokenForm?.siteId?.length > 0 && tokenForm?.siteId?.length < 3) && <div id="validationSalesToken" className="invalid-feedback text-red">
                                <strong>Sales token must be greater than or equal to three characters.</strong>
                            </div>}
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">Description:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="name" value={tokenForm?.name} onChange={onChange(null)} />
                        </div>
                    </div>
                    {isAdmin && <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">Disable Alert Notification View:</label>
                        <div class="col-sm-6 d-flex align-self-center">
                            <input type="checkbox" 
                                name="disableAlertNotificationView" 
                                checked={tokenForm?.attr?.disableAlertNotificationView ? "checked": ""} 
                                onChange={onChange("attr", true)} />
                        </div>
                    </div>}
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Logo:</label>
                        <div className={tokenForm?.attr?.logo ? 'col-sm-3': 'col-sm-6'}>
                            <input type="file" class="form-control" onChange={onLogoChange} />
                        </div>
                        {tokenForm?.attr?.logo && <div class="col-sm-3">
                            <img src={tokenForm?.attr?.logo} style={{width:"100%"}} />
                        </div>}
                    </div>
                    <div class="form-group row m-b-10 ml-1">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" name="isAffiliate" id={"toggleIsAffiliate"} onChange={onChange("attr", true)} checked={tokenForm?.attr?.isAffiliate ? "checked" : "" } />
                            <label class="custom-control-label" htmlFor={"toggleIsAffiliate" }>
                                {tokenForm?.attr?.isAffiliate ? "Affiliate" : "Agent"}
                            </label>
                        </div>
                    </div>
                    {!tokenForm?.attr?.isAffiliate && <>
                        <div class="form-group row m-b-10">
                            <label class="col-form-label col-sm-3" for="given_name">Agent First Name:</label>
                            <div class="col-sm-6">
                                <input type="text" class={`form-control${users.length > 0 ? "-plaintext" : ""}`} name="given_name" value={users.length > 0 ? users[0].given_name : userForm?.given_name} onChange={onChangeUser(null)} />
                            </div>
                        </div>
                        <div class="form-group row m-b-10">
                            <label class="col-form-label col-sm-3" for="family_name">Agent Last Name:</label>
                            <div class="col-sm-6">
                                <input type="text" class={`form-control${users.length > 0 ? "-plaintext" : ""}`} name="family_name" value={users.length > 0 ? users[0].family_name : userForm?.family_name} onChange={onChangeUser(null)} />
                            </div>
                        </div>
                        <div class="form-group row m-b-10">
                            <label class="col-form-label col-sm-3" for="email">Email:</label>
                            <div class="col-sm-6">
                                <input type="text" class={`form-control${users.length > 0 ? "-plaintext" : ""}`} name="email" value={users.length > 0 ? users[0].email : userForm?.email} onChange={onChangeUser(null)} />
                            </div>
                        </div>
                        {users?.length === 0 && <div class="form-group row m-b-10">
                            <label class="col-form-label col-sm-3" for="password">Password:</label>
                            <div class="col-sm-6">
                                <input type="text" class="form-control" name="password" disabled={"disabled"} value={users.length > 0 ? users[0].password : userForm?.password} />
                            </div>
                        </div>}
                        <div class="form-group row m-b-10 ml-1">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" name="enableSiteAlerts" id={"toggleSiteAlerts"} onChange={users?.length > 0 ? saveUser(users[0], 0) : onChangeUser(true)} checked={users.length > 0 ? users[0].enableSiteAlerts ? "checked" : userForm.enableSiteAlerts ? "checked" : "" : "" } />
                                <label class="custom-control-label" htmlFor={"toggleSiteAlerts" }>Toggle Site Alerts</label>
                            </div>
                        </div>
                    </>}
                </form>
            </div>
        </div>
        <SidePanelToggle autoCloseOnBlur overrideActiveState={refServicePanel} showIconOnActive onClick={() =>setRefServicePanel(false)}>
            <SalesTokenCompanies salesTokenSite={tokenForm} />
        </SidePanelToggle>
    </>
}

export default SalesTokenModification